import React from "react";
import { Result, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

const UnauthorizedView = ({ fetchData }) => {
  return (
    <div style={{ marginTop: 150 }}>
      <Result
        status="403"
        title="Không có quyền truy cập"
        subTitle="Bạn không nằm trong danh sách cổ đông tham dự đại hội."
        extra={
          <Button icon={<ReloadOutlined />} type="primary" onClick={fetchData}>
            Tải lại trang
          </Button>
        }
      />
    </div>
  );
};

export default UnauthorizedView;
